var map = {
	"./activities.png": 2708,
	"./night-dance.png": 5807,
	"./radio/deejay.png": 1913,
	"./radio/virgin.png": 1668,
	"./rock.png": 4940,
	"./sunset-party.png": 5377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3092;